import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { mockStrictLocalize } from "@faire/web--source/common/testing/unit/mockStrictLocalize";
import { MessengerStore } from "@faire/web--source/messenger/store/MessengerStore";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
/**
 * Factory methods to get access to messenger related classes.
 * @deprecated prefer to use `useMessengerFactory` or `withStores` instead
 */ export var MessengerFactory = /*#__PURE__*/ function() {
    "use strict";
    function MessengerFactory() {
        _class_call_check(this, MessengerFactory);
    }
    _create_class(MessengerFactory, [
        {
            key: "messengerStore",
            get: function get() {
                return this._messengerStore || new MessengerStore(UserStore.get().user, mockStrictLocalize);
            },
            set: function set(messengerStore) {
                this._messengerStore = messengerStore;
            }
        }
    ]);
    return MessengerFactory;
}();
MessengerFactory.get = singletonGetter(MessengerFactory);
export var useMessengerFactory = createStoreHook(MessengerFactory);
